import originalMediaDevices from 'media-devices';

interface MediaDevicesWrapper {
  getUserMedia(constraints: MediaStreamConstraints): Promise<MediaStream>;
  enumerateDevices(): Promise<MediaDeviceInfo[]>;
}

const mediaDevices: MediaDevicesWrapper = {
  getUserMedia: (constraints) =>
    (originalMediaDevices as any).getUserMedia(constraints),
  enumerateDevices: () =>
    (originalMediaDevices as any).enumerateDevices(),
};

export default mediaDevices;



